// @flow

/**
 * Get URL param by name
 *
 * @param {String} nameParam The param to search for
 *
 * @return {String} The value found for nameParam (if any)
 */
const getURLParam = (nameParam: string) => {
  const url = window.location.href;
  const name = nameParam.replace(/[[\]]/g, '\\$&');

  const regex = new RegExp(`[#?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return null;

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export default getURLParam;
